import { DeleteOutlined, SearchOutlined} from '@ant-design/icons';
import { Breadcrumb, Button, Col, Form, Input, Pagination, Popconfirm, Row, Space, Table, Tabs, Tooltip, message,} from 'antd';
import 'jspdf-autotable';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import TabPane from 'antd/es/tabs/TabPane';
import { bunldeUnVerifyListById, bunldeVerifyListById, editstockverifyTwo } from '../../slices/stock-verify';

function EditReport() {
    const dispatch = useDispatch();
    const { id } = useParams();
    const [form] = Form.useForm();
    const [verifyPage, setVerifyPage] = useState(1);
    const [verifyPageSize, setVerifyPageSize] = useState(20);
    const [verifyData, setVerifyData] = useState(null);
    const [verifyCount, setVerifyCount] = useState(0);
    const [searchVerifyList, setSearchVerifyList] = useState(localStorage.getItem('editBundleVerification') || '');
    const [inputVerificationValue, setVerificationInputValue] = useState(localStorage.getItem('editBundleVerification') || '');
    const [orderByVerifyList, setOrderByVerifyList] = useState('');
    const [unverifyPage, setUnverifyPage] = useState(1);
    const [unverifyPageSize, setUnverifyPageSize] = useState(20);
    const [unverifyData, setUnVerifyData] = useState(null);
    const [unverifyCount, setUnVerifyCount] = useState(0);
    const [searchUnverify, setSearchUnverify] = useState(localStorage.getItem('editBundleUnVerification') || '');
    const [inputUnverifyValue, setInputUnverifyValue] = useState(localStorage.getItem('editBundleUnVerification') || '');
    const [orderByUnverify, setOrderByUnverify] = useState('');
    const [activeTab, setActiveTab] = useState('1');
    const [loading, setLoading] = useState(false);
    const dataSource = verifyData?.map((item, index) => ({
        ...item,
        key: item.id || index,
        SrNo: ((verifyPage - 1) * verifyPageSize) + index + 1,
    }));

    const dataSourceTwo = unverifyData?.map((item, index) => ({
        ...item,
        key: item.id || index,
        SrNo: ((unverifyPage - 1) * unverifyPageSize) + index + 1,
    }));

    useEffect(() => {
        if (activeTab === undefined) {
            setActiveTab('1');
        }
    }, [activeTab]);



    const columns = [
        {
            title: 'Bunlde No.',
            dataIndex: 'bundle_no',
            key: 'bundle_no',
            width: '8%',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => (status ? 'Verified' : 'Unverified'),
        },
        {
            title: 'Profile No',
            dataIndex: 'die_profile',
            key: 'die_profile',
        },
        {
            title: 'Length',
            dataIndex: 'length',
            key: 'length',
        },
        {
            title: 'Pieces',
            dataIndex: 'pieces',
            key: 'pieces',
        },
        {
            title: 'Weight',
            dataIndex: 'weight',
            key: 'weight',
            render: weight => {
                return (
                    <span>
                        {weight !== null && weight !== undefined
                            ? weight.toFixed(3)
                            : 'N/A'}
                    </span>
                );
            },
        },
        {
            title: 'Avg. Weight',
            dataIndex: 'avg_weight',
            key: 'avg_weight',
            render: avg_weight => {
                return (
                    <span>
                        {avg_weight !== null && avg_weight !== undefined
                            ? avg_weight.toFixed(3)
                            : 'N/A'}
                    </span>
                );
            },
        },
        {
            title: 'Alloy',
            dataIndex: 'alloy',
            key: 'alloy',
        },
        {
            title: 'Customer Name',
            dataIndex: 'party',
            key: 'party',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Link>
                        <Tooltip title="Delete">
                            <Popconfirm
                                title="Are you sure you want to Delete this record?"
                                onCancel={() => message.info('Action cancelled')}
                                okText="Yes"
                                cancelText="No"
                            >
                                <DeleteOutlined style={{ cursor: 'pointer', fontSize: '18px' }} />
                            </Popconfirm>
                        </Tooltip>
                    </Link>
                </Space>
            ),
        },
    ];

    const columnsTwo = [
        {
            title: 'Bunlde No.',
            dataIndex: 'bundle_no',
            key: 'bundle_no',
            width: '8%',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => (status ? 'Verified' : 'Unverified'),
        },
        {
            title: 'Profile No',
            dataIndex: 'die_profile',
            key: 'die_profile',
        },
        {
            title: 'Length',
            dataIndex: 'length',
            key: 'length',
        },
        {
            title: 'Pieces',
            dataIndex: 'pieces',
            key: 'pieces',
        },
        {
            title: 'Weight',
            dataIndex: 'weight',
            key: 'weight',
            render: weight => {
                return (
                    <span>
                        {weight !== null && weight !== undefined
                            ? weight.toFixed(3)
                            : 'N/A'}
                    </span>
                );
            },
        },
        {
            title: 'Avg. Weight',
            dataIndex: 'avg_weight',
            key: 'avg_weight',
            render: avg_weight => {
                return (
                    <span>
                        {avg_weight !== null && avg_weight !== undefined
                            ? avg_weight.toFixed(3)
                            : 'N/A'}
                    </span>
                );
            },
        },
        {
            title: 'Alloy',
            dataIndex: 'alloy',
            key: 'alloy',
        },
        {
            title: 'Customer Name',
            dataIndex: 'party',
            key: 'party',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Link>
                        <Tooltip title="Delete">
                            <Popconfirm
                                title="Are you sure you want to Delete this record?"
                                onCancel={() => message.info('Action cancelled')}
                                okText="Yes"
                                cancelText="No"
                            >
                                <DeleteOutlined style={{ cursor: 'pointer', fontSize: '18px' }} />
                            </Popconfirm>
                        </Tooltip>
                    </Link>
                </Space>
            ),
        },
    ];

    const handleTabChange = key => {
        setActiveTab(key);
    };
    const debounceTimeout = useRef(null);
    const debouncedSearch = (value, isVerifyTab) => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            if (isVerifyTab) {
                setSearchVerifyList(value);
                setVerifyPage(1); // Reset to first page when searching
                localStorage.setItem('editBundleVerification', value);
            } else {
                setSearchUnverify(value);
                setUnverifyPage(1); // Reset to first page when searching
                localStorage.setItem('editBundleUnVerification', value);
            }
        }, 500); // 500ms debounce
    };

    const fetchBothData = async () => {
        setLoading(true);
        try {
            const unverifyResponse = await dispatch(
                bunldeUnVerifyListById({
                    report_id: id,
                    page: unverifyPage,
                    pagesize: unverifyPageSize,
                    ...(searchUnverify && { search: searchUnverify }),
                    ...(orderByUnverify && { ordering: orderByUnverify }),
                })
            );

            if (bunldeUnVerifyListById.fulfilled.match(unverifyResponse)) {
                setUnVerifyCount(unverifyResponse.payload.count);
                setUnVerifyData(unverifyResponse.payload.results.data);
            }
            const verifyResponse = await dispatch(
                bunldeVerifyListById({
                    report_id: id,
                    page: verifyPage,
                    pagesize: verifyPageSize,
                    ...(searchVerifyList && { search: searchVerifyList }),
                    ...(orderByVerifyList && { ordering: orderByVerifyList }),
                })
            );

            if (bunldeVerifyListById.fulfilled.match(verifyResponse)) {
                setVerifyCount(verifyResponse.payload.count);
                setVerifyData(verifyResponse.payload.results.data);
            }
        } catch (error) {
            console.error('Error in dispatching:', error);
            message.error('Failed to fetch data');
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchBothData();
    }, [
        id,
        unverifyPage,
        unverifyPageSize,
        verifyPage,
        verifyPageSize,
        searchUnverify,
        searchVerifyList,
        orderByUnverify,
        orderByVerifyList
    ]);
    const handleSearch = (e) => {
        const value = e.target.value;
        setInputUnverifyValue(value);
        debouncedSearch(value, false);
    };

    const handleSearchVerifyList = (e) => {
        const value = e.target.value;
        setVerificationInputValue(value);
        debouncedSearch(value, true);
    };
    const resetFilter = () => {
        setSearchUnverify('');
        setInputUnverifyValue('');
        setOrderByUnverify('');
        localStorage.removeItem('editBundleUnVerification');
        setUnverifyPage(1);
    };

    const resetFilterVerifyList = () => {
        setSearchVerifyList('');
        setVerificationInputValue('');
        setOrderByVerifyList('');
        localStorage.removeItem('editBundleVerification');
        setVerifyPage(1);
    };
    const handleUnverifyPageChange = (page, pageSize) => {
        setUnverifyPage(page);
        if (pageSize) setUnverifyPageSize(pageSize);
    };

    const handleVerifyPageChange = (page, pageSize) => {
        setVerifyPage(page);
        if (pageSize) setVerifyPageSize(pageSize);
    };
    const onSubmit = async values => {
        try {
            const bundleNo = document.getElementById('bundle_no').value;
            if (!bundleNo) {
                message.error('Please enter a bundle number');
                return;
            }

            const encodedBundleNumber = encodeURIComponent(bundleNo);
            await dispatch(editstockverifyTwo({
                bundle_number: encodedBundleNumber,
                report_id: id
            })).unwrap();

            message.success('Bundle Verified successfully!');
            form.resetFields(['bundle_no']);
            fetchBothData();

        } catch (error) {
            if (typeof error === 'object' && error !== null) {
                const messages = [];
                for (const key in error) {
                    if (Array.isArray(error[key])) {
                        messages.push(`${key}: ${error[key].join(', ')}`);
                    }
                }

                if (messages.length > 0) {
                    message.error(messages.join('; '));
                } else {
                    message.error('Bundle verification failed');
                }
            } else if (typeof error === 'string') {
                message.error(error);
            } else {
                message.error('Bundle verification failed');
            }
        }
    };

    return (
        <div>
            <div className="sticyaction">
                <div className="sticky-header">
                    <Row
                        className="pagenamerow mb-0 "
                        justify="space-between"
                        align="middle"
                    >
                        <Col>
                            <h2 style={{ margin: 0 }}>Edit Bundle Verification Report</h2>
                            <div className="bredcrumbwrp">
                                <Link to="/stock-verification" className="back">
                                    <Back /> BACK
                                </Link>
                                <Breadcrumb
                                    items={[
                                        { title: <Link to="/dashboard">Home</Link> },
                                        { title: <Link to="/stock-verification">Stock Verification Report</Link> },
                                        { title: 'Edit Bundle Verification Report' },
                                    ]}
                                />
                            </div>
                        </Col>
                        <Col>
                            <Space size="small">
                                <Input
                                    placeholder="Search"
                                    className='searchbox'
                                    prefix={<SearchOutlined />}
                                    value={activeTab === '1' ? inputUnverifyValue : inputVerificationValue}
                                    onChange={e => {
                                        if (activeTab === '1') handleSearch(e);
                                        else handleSearchVerifyList(e);
                                    }}
                                    style={{ width: '100%' }}
                                />
                                <Tooltip title="Filter">
                                    <Button
                                        type="primary"
                                        disabled={
                                            activeTab === '1'
                                                ? !searchUnverify && !orderByUnverify
                                                : !searchVerifyList && !orderByVerifyList
                                        }
                                        className="iconlink"
                                        onClick={() => {
                                            if (activeTab === '1') {
                                                resetFilter();
                                            } else {
                                                resetFilterVerifyList();
                                            }
                                        }}
                                    >
                                        <FilterIcon />
                                    </Button>
                                </Tooltip>
                            </Space>
                        </Col>
                    </Row>
                </div>
                <div className="mb-3 mt-3" style={{
                    backgroundColor: '#e0f2f7',
                    padding: '15px', paddingBottom: "0",
                    borderRadius: '5px',
                    width: '100%',
                }}>
                    <Form layout="vertical" form={form} onFinish={onSubmit}>
                        <Row gutter={16} style={{ alignItems: 'flex-end' }}>
                            <Col xs={24} md={8}>
                                <Form.Item name='bundle_no'>
                                    <label className='clmlbl'>Bundle No :</label>
                                    <Input placeholder="Enter Bundle No." id="bundle_no" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={16}>
                                <Form.Item>
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        <Button
                                            type="primary"
                                            className="iconlink"
                                            htmlType="submit">
                                            Verify Bundle
                                        </Button>
                                    </div>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>

            <div className='px-4'
                style={{ position: 'sticky', top: 0, zIndex: 1000, background: '#fff' }}
            >
                <Tabs defaultActiveKey="1"
                    className="tabletab px-4"
                    activeKey={activeTab}
                    onChange={handleTabChange}
                >
                    <TabPane tab={`Unverified Bundles (${unverifyCount})`} key="1">
                        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
                            <div style={{ flex: 1, }}>
                                <Table
                                    rowKey="id"
                                    dataSource={dataSourceTwo}
                                    columns={columnsTwo}
                                    pagination={false} // Disable built-in pagination
                                    loading={loading}
                                    scroll={{ x: 1100 }}
                                />
                            </div>
                            <div
                                style={{
                                    position: 'sticky',
                                    bottom: 0,
                                    zIndex: 1000,
                                    background: '#fff',
                                    padding: 10,
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                }}
                            >
                                <Pagination
                                    current={unverifyPage}
                                    pageSize={unverifyPageSize}
                                    total={unverifyCount}
                                    showSizeChanger
                                    onChange={handleUnverifyPageChange}
                                    pageSizeOptions={["20", "50", "100"]}
                                    showTotal={total => `Total ${total} items`}
                                    locale={{ items_per_page: 'Items / Page' }}
                                />
                            </div>
                        </div >
                    </TabPane>

                    <TabPane tab={`Verified Bundles (${verifyCount})`} key="2">
                        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
                            <div style={{ flex: 1, }}>
                                <Table
                                    className='px-0'
                                    rowKey="id"
                                    columns={columns}
                                    dataSource={dataSource}
                                    pagination={false} // Disable built-in pagination
                                    loading={loading}
                                    scroll={{ x: '600px' }}
                                />
                            </div>
                            <div
                                style={{
                                    position: 'sticky',
                                    bottom: 0,
                                    zIndex: 1000,
                                    background: '#fff',
                                    padding: 10,
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                }}
                            >
                                <Pagination
                                    current={verifyPage}
                                    pageSize={verifyPageSize}
                                    total={verifyCount}
                                    showSizeChanger
                                    onChange={handleVerifyPageChange}
                                    pageSizeOptions={["20", "50", "100"]}
                                    showTotal={total => `Total ${total} items`}
                                    locale={{ items_per_page: 'Items / Page' }}
                                />
                            </div>
                        </div>
                    </TabPane>
                </Tabs>
            </div>
        </div>
    );
}

export default EditReport;